import {PromotionQualifier} from '@gongxigames/framework/promotions';

export type PromotionBalanceEntryQualifier = PromotionQualifier;